const T_PREFIX = "clone-settings";

export const cloneImagesFieldTrns = {
  logo: `${T_PREFIX}.images-field.logo`,
  mainPhoto: `${T_PREFIX}.images-field.main-photo`,
};

export const cloneActionButtonsTrns = {
  cancelButton: `${T_PREFIX}.action-buttons.cancel-btn`,
  publishButton: `${T_PREFIX}.action-buttons.publish-btn`,
};
